import { optimalBluePricingApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';

export const getOptimalBlueLaunchUrlAction = catchAsyncActionError(
  ({ applicationId }) =>
    async () => {
      const { data } = await optimalBluePricingApi.getLaunchUrl({ applicationId });

      return data?.launchUrl ?? null;
    },
);
